module.exports = __webpack_public_path__ + "img/ambiental-2.34a0aa9d.jpg";